// ABOUTME: Utility functions and constants for email campaign management
// ABOUTME: Provides label mappings, validation helpers, and formatting functions

import { CampaignExitCondition } from '../types/emailCampaign';

export const EXIT_CONDITION_LABELS: Record<CampaignExitCondition, string> = {
  [CampaignExitCondition.None]: "Never auto-exit",
  [CampaignExitCondition.SubscriptionActive]: "When subscription becomes active",
  [CampaignExitCondition.UserDeleted]: "When user is deleted",
  [CampaignExitCondition.FamilyArchived]: "When family is archived",
  [CampaignExitCondition.TrialEnded]: "When trial period expires",
  [CampaignExitCondition.AllStepsCompleted]: "Campaign complete"
};

export const EXIT_CONDITION_DESCRIPTIONS: Record<CampaignExitCondition, string> = {
  [CampaignExitCondition.None]: "Family must be manually unenrolled from this campaign",
  [CampaignExitCondition.SubscriptionActive]: "Family will be automatically unenrolled when they subscribe",
  [CampaignExitCondition.UserDeleted]: "Family will be automatically unenrolled when user account is deleted",
  [CampaignExitCondition.FamilyArchived]: "Family will be automatically unenrolled when family is archived",
  [CampaignExitCondition.TrialEnded]: "Family will be automatically unenrolled when trial expires",
  [CampaignExitCondition.AllStepsCompleted]: "Family will be automatically unenrolled after receiving final email"
};

export function formatTimeForAPI(time: Date | null): string {
  if (!time) return "09:00:00";

  const hours = time.getHours().toString().padStart(2, '0');
  const minutes = time.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}:00`;
}

export function parseTimeFromAPI(timeString: string): Date {
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
}
